import React, { useState, useEffect } from 'react';
import '../css/crystal.css';

export default function CrystalDifference() {
  const data = [
    {
      left: {
        description:
          'Gives better compressive strength as compared to river sand.',
        number: '01',
      },
      right: {
        description:
          'Gives low compressive strength as compared to crystal sand.',
      },
    },
    {
      left: {
        description:
          'As the voids are filled properly, strength of the concrete is achieved.',
        number: '02',
      },
      right: {
        description:
          'As the voids are not filled properly, strength of the concrete is not achieved.',
      },
    },
    {
      left: {
        description:
          'Can be produced in ample quantity, so it is cheaper as compared to natural sand.',
        number: '03',
      },
      right: {
        description: 'Available in less quantity so it is costlier.',
      },
    },
    {
      left: {
        description:
          'Crystal sand is made from only one type of stone, hence the binding strength between the particles is good.',
        number: '04',
      },
      right: {
        description:
          'It is made from different types of stones, so binding strength varies.',
      },
    },
    {
      left: {
        description:
          'Crystal sand has constant fineness modules of aggregate, so no necessity of the change in concrete mix design.',
        number: '05',
      },
      right: {
        description:
          'As every truck of natural sand has different fineness modules, every time the mixture of concrete has to be changed.',
      },
    },
    {
      left: {
        description:
          'Crystal sand is made up from 100% recycled glasses which does not affect the nature.',
        number: '06',
      },
      right: {
        description:
          'Due to sand dragging, it’s harmful to nature.',
      },
    },
    {
      left: {
        description:
          'This sand is best as per Vastu Shastra, as it doesn’t contain any pieces of lime etc.',
        number: '07',
      },
      right: {
        description:
          'This sand contains pieces of lime etc. So it is not suitable as per Vastu Shastra.',
      },
    },
    {
      left: {
        description:
          'Crystal sand doesn’t contain impurities like silt, silica, organic material, etc., so strength of the structure remains the same.',
        number: '08',
      },
      right: {
        description:
          'This sand contains impurities like silt, silica, organic impurities that weakens the strength of the structure.',
      },
    },
    {
      left: {
        description:
          'This sand has proper gradation of coarse and fine aggregates, so voids are filled completely. This minimizes cement consumption.',
        number: '09',
      },
      right: {
        description:
          'Natural sand which is available today doesn’t have fines in proper gradation. So, voids in the concrete are not filled properly and also increases cement consumption.',
      },
    },
  ];

  const [visibleRows, setVisibleRows] = useState(5);
  const [showParticles, setShowParticles] = useState(false);
  const [isToggleEnabled, setIsToggleEnabled] = useState(true);

  // Check screen size on mount and on resize
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 1440) {
        setVisibleRows(data.length); // Show all rows for screens < 1440px
        setIsToggleEnabled(false); // Disable toggle
      } else {
        setVisibleRows(5); // Reset to 5 rows for screens >= 1440px
        setIsToggleEnabled(true); // Enable toggle
      }
    };

    handleResize(); // Run on mount
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [data.length]);

  const toggleView = () => {
    if (!isToggleEnabled) return; // Do nothing if toggle is disabled

    const screenWidth = window.innerWidth;
    let height;
    if (screenWidth <= 1600) {
      height = isViewMore ? '175vw' : '110vw';
    } else {
      height = isViewMore ? '140vw' : '110vw';
    }

    setVisibleRows(isViewMore ? data.length : 5);

    // Update the height dynamically
    const programSection = document.querySelector(
      '.crystal-sand .section.program'
    );
    const programSpacer = document.querySelector(
      '.crystal-sand .section-spacer.programs'
    );
    if (programSection) programSection.style.height = height;
    if (programSpacer) programSpacer.style.height = height;
  };

  const isViewMore = visibleRows < data.length;

  const generateParticles = () => {
    const particles = [];
    for (let i = 0; i < 50; i++) {
      particles.push(
        <div
          key={i}
          className="particle"
          style={{
            '--x': `${Math.random() * 200 - 100}px`,
            '--y': `${Math.random() * 200 - 100}px`,
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animation: `particleFloat ${1 + Math.random() * 2}s infinite`,
          }}
        ></div>
      );
    }
    return particles;
  };

  return (
    <div className="crystal-dif">
      <div className="container">
        <h2 className="heading-font">Crystal Sand VS. Natural Sand</h2>
        {data.slice(0, visibleRows).map((row, index) => (
          <div className="row forSameFonts" key={index}>
            <div
              className="column left"
              style={{ background: row.left.background }}
            >
              <p>{row.left.description}</p>
            </div>
            <div
              className="number-circle"
              style={{
                border: `2px solid ${row.left.background || '#107ea1'}`,
              }}
            >
              {row.left.number}
            </div>
            <div className="column right">
              <p>{row.right.description}</p>
            </div>
          </div>
        ))}
        {isToggleEnabled && (
          <div
            className="toggle-button-wrapper"
            onMouseEnter={() => setShowParticles(true)}
            onMouseLeave={() => setShowParticles(false)}
          >
            <button className="toggle-button" onClick={toggleView}>
              {isViewMore ? 'View More' : 'View Less'}
            </button>
            {showParticles && (
              <div className="particles-field">{generateParticles()}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}